import { Store } from 'pullstate'

const DashboardsStore = new Store({ });

export default DashboardsStore;